import React from "react";

type PropsType = {
  color?: string;
  style?: React.CSSProperties;
  size?: number;
};

const MapleLeaf = ({ size = 24, style = {}, color = "#D5202C" }: PropsType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      style={style}
      viewBox={`0 0 24 24`}
      fill="none"
    >
      <g clip-path="url(#clip0_1_376)">
        <path
          d="M12.2689 18.8605L12.5379 24H11.462L11.731 18.8605C11.7349 18.776 11.7197 18.6917 11.6866 18.6138C11.6535 18.5359 11.6032 18.4664 11.5396 18.4104C11.4759 18.3544 11.4005 18.3133 11.3188 18.2902C11.2371 18.2671 11.1512 18.2626 11.0675 18.2769L5.93308 19.1762L6.62644 17.2705C6.65457 17.1946 6.65817 17.1119 6.63673 17.034C6.61529 16.956 6.56989 16.8867 6.5069 16.8357L0.882324 12.2978L2.1495 11.7082C2.23508 11.6679 2.30295 11.5979 2.34037 11.5112C2.37779 11.4246 2.38218 11.3273 2.35272 11.2377L1.24096 7.83127L4.48062 8.51613C4.56839 8.53436 4.65978 8.52179 4.73931 8.48054C4.81884 8.4393 4.8816 8.37192 4.91695 8.28983L5.54456 6.81886L8.07293 9.52258C8.13074 9.58334 8.20677 9.62378 8.2896 9.63785C8.37243 9.65191 8.45761 9.63885 8.53236 9.6006C8.60711 9.56236 8.6674 9.501 8.70418 9.42573C8.74097 9.35046 8.75228 9.26534 8.73641 9.18313L7.51705 2.91811L9.4716 4.04367C9.51749 4.07047 9.56842 4.08759 9.62122 4.09398C9.67402 4.10037 9.72758 4.09589 9.77857 4.08081C9.82956 4.06574 9.87691 4.04039 9.91767 4.00635C9.95843 3.9723 9.99174 3.93028 10.0155 3.88288L12 0L13.9844 3.88288C14.0082 3.93028 14.0415 3.9723 14.0823 4.00635C14.123 4.04039 14.1704 4.06574 14.2214 4.08081C14.2724 4.09589 14.3259 4.10037 14.3787 4.09398C14.4315 4.08759 14.4825 4.07047 14.5283 4.04367L16.4829 2.91811L15.2635 9.18313C15.2477 9.26534 15.259 9.35046 15.2958 9.42573C15.3326 9.501 15.3928 9.56236 15.4676 9.6006C15.5423 9.63885 15.6275 9.65191 15.7103 9.63785C15.7932 9.62378 15.8692 9.58334 15.927 9.52258L18.4554 6.81886L19.083 8.28983C19.1183 8.37192 19.1811 8.4393 19.2606 8.48054C19.3402 8.52179 19.4316 8.53436 19.5193 8.51613L22.759 7.83127L21.6472 11.2377C21.6178 11.3273 21.6222 11.4246 21.6596 11.5112C21.697 11.5979 21.7649 11.6679 21.8504 11.7082L23.1176 12.2978L17.493 16.8357C17.4301 16.8867 17.3847 16.956 17.3632 17.034C17.3418 17.1119 17.3454 17.1946 17.3735 17.2705L18.0669 19.1762L12.9324 18.2769C12.8487 18.2626 12.7629 18.2671 12.6812 18.2902C12.5995 18.3133 12.524 18.3544 12.4604 18.4104C12.3967 18.4664 12.3465 18.5359 12.3133 18.6138C12.2802 18.6917 12.265 18.776 12.2689 18.8605Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_376">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MapleLeaf;
